export default "__VITE_ASSET__c541e82b__"